import { reskinStyles } from 'core/components/theme/theme-variant';

const styles = (theme) => ({
  iconButtonRoot: {
    color: theme.colors.action_icon,
    padding: 0,
    ...reskinStyles(theme, { padding: theme.spacing(1), alignSelf: 'center' })
  },
  iconButtonLabel: {
    height: 24,
    width: 24,
    '& > img': {
      height: 24,
      width: 24
    }
  },
  'big-iconButtonRoot': {
    color: theme.colors.action_icon,
    padding: 8,
    // Reskin: a 40px hover circle hugging the icon, not stretched by the row into a tall oval.
    ...reskinStyles(theme, { padding: 4, alignSelf: 'center' })
  },
  'big-iconButtonLabel': {
    height: 32,
    width: 32,
    '& > img': {
      height: 32,
      width: 32
    }
  }
});

export default styles;
